module.exports = __webpack_public_path__ + "static/media/app-info.2b7c7d8a.jpeg";